import { computed, Injectable, signal } from '@angular/core';

@Injectable()
export class LayoutService {
  #searchVisible = signal<boolean>(true);
  #rightMenuOpened = signal<boolean>(false);
  #leftMenuOpened = signal<boolean>(false);
  showSearch = computed(() => {
    return this.#searchVisible();
  });
  rightMenuOpened = computed(() => {
    return this.#rightMenuOpened();
  });
  leftMenuOpened = computed(() => {
    return this.#leftMenuOpened();
  });

  toggleSearch(value?: boolean): void {
    this.#searchVisible.update(val => value ?? !val);
  }

  toggleRightMenu(value?: boolean): void {
    this.#rightMenuOpened.update(val => value ?? !val);
  }

  toggleLeftMenu(value?: boolean): void {
    this.#leftMenuOpened.update(val => value ?? !val);
  }
}
